import { render } from "./ShareProduct.vue?vue&type=template&id=4f6a4113&scoped=true"
import script from "./ShareProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareProduct.vue?vue&type=script&setup=true&lang=js"

import "./ShareProduct.vue?vue&type=style&index=0&id=4f6a4113&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6a4113"],['__file',"resources/js/components/whatsapp-managment/includes/ShareProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f6a4113"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f6a4113', __exports__)) {
    console.log('reload')
    api.reload('4f6a4113', __exports__)
  }
  
  module.hot.accept("./ShareProduct.vue?vue&type=template&id=4f6a4113&scoped=true", () => {
    console.log('re-render')
    api.rerender('4f6a4113', render)
  })

}


export default __exports__